export default __webpack_public_path__ + "static/media/logo.aa411770.png";